import {RouteAccess} from '~/shared/types/types';

export const routeAccessConfig: RouteAccess[] = [
  {path: '/accounts', roles: ['buyer', 'admin', 'farmer']},
  {path: '/templates', roles: ['buyer', 'admin']},
  {path: '/users', roles: ['admin', 'buyer']},
  {path: '/launch-history', roles: ['admin', 'buyer']},
  {path: '/dictionaries/cta', roles: ['admin', 'buyer']},
];

export const hasAccess = (roles: string[], path: string): boolean => {
  const route = routeAccessConfig.find(r => r.path === path);
  if (!route) return false;
  return route.roles.some(r => roles.includes(r));
};
